import React from "react";

// Skeleton for the student "Statistiques" tab while data loads.
// Mirrors: 6 summary cards + two chart blocks (histogram, bodyweight).
export default function StatsSkeleton() {
	return (
		<div className="stats-skeleton" aria-busy="true" aria-label="Chargement des statistiques">
			<div className="stats-summary-cards">
				{Array.from({ length: 6 }).map((_, i) => (
					<div key={i} className="stats-card">
						<span className="skeleton skeleton-line" style={{ width: "55%", height: 22, margin: "0 auto 8px" }} />
						<span className="skeleton skeleton-line sm" style={{ width: "80%", margin: "0 auto" }} />
					</div>
				))}
			</div>

			{[200, 160].map((h, i) => (
				<div key={i} className="stats-skeleton-block">
					<span className="skeleton skeleton-line" style={{ width: i === 0 ? 240 : 180, height: 13, marginBottom: 14 }} />
					<span className="skeleton" style={{ display: "block", width: "100%", height: h, borderRadius: 8 }} />
				</div>
			))}
		</div>
	);
}
